import { get, post } from './http-calls';

export const getWorkshopShiftWeeklyData = async (branchID, year, isoWeekNumber) => {
    let res = await get(
        `WorkshopShiftSchedule/WorkshopShift_GetWeeklyData?BranchID=${branchID || ''}&Year=${year || ''}&ISOWeekNumber=${isoWeekNumber || ''}`,
        {
            useAuthToken: true
        }
    );
    return res;
};

export const postWorkshopShiftSchedulesAddUpdate = async (data) => {
    let res = await post(`WorkshopShiftSchedule/WorkshopShiftSchedulesAddUpdate`, data, {
        useAuthToken: true
    });
    return res;
};

export const postWorkshopShiftAssignmentsAddUpdate = async (data) => {
    let res = await post(`WorkshopShiftSchedule/WorkshopShiftAssignmentsAddUpdate`, data, {
        useAuthToken: true
    });
    return res;
};

export const postWorkshopShiftAssignmentsDelete = async (data) => {
    let res = await post(`WorkshopShiftSchedule/WorkshopShiftAssignments_Delete`, data, {
        useAuthToken: true
    });
    return res;
};

export const getWorkshopShiftsTechniciansByBranch = async (branchID) => {
    let res = await get(
        `WorkshopShiftSchedule/WorkshopShifts_GetTechniciansByBranch?BranchID=${branchID || ''}`,
        {
            useAuthToken: true
        }
    );
    return res;
};
export const postWorkshopShiftAddHolidayAndRemoveAssignments = async (data) => {
    let res = await post(`WorkshopShiftSchedule/WorkshopShift_AddHolidayAndRemoveAssignments`, data, {
        useAuthToken: true
    });
    return res;
};
